import { AxiosResponse } from "axios";

import {
  IEmailTemplate,
  IEmailTemplateType,
  ISaveEmailTemplateRequest,
  ITestEmailTemplateRequest,
} from "../../@types/admin/AdminEmailTemplate";
import { api } from "../api";

/**
 * Custom email templates admin page (EN-5162), migrated from the Retool
 * EmailTemplates app.
 *
 * ⚠️ `wardId` fills the route's `{hospitalId}` segment. That is what Retool
 * sends and what the service resolves — the segment is misnamed, not the
 * argument.
 */
export const emailTemplatesService = {
  async getEmailTemplate(
    wardId: number,
    templateType: IEmailTemplateType
  ): Promise<AxiosResponse<IEmailTemplate>> {
    return api.get<IEmailTemplate>(
      `/Retool/HospitalEmailTemplates/Hospital/${wardId}/Template/${templateType}`
    );
  },

  async saveEmailTemplate(
    wardId: number,
    templateType: IEmailTemplateType,
    request: ISaveEmailTemplateRequest
  ): Promise<AxiosResponse<IEmailTemplate>> {
    return api.put<IEmailTemplate>(
      `/Retool/HospitalEmailTemplates/Hospital/${wardId}/Template/${templateType}`,
      request
    );
  },

  /** ⚠️ Sends a real email. Only ever call this from an explicit confirm. */
  async sendTestEmail(
    request: ITestEmailTemplateRequest
  ): Promise<AxiosResponse<void>> {
    return api.post<void>(
      "/Retool/HospitalEmailTemplates/TestTemplate",
      request
    );
  },
};
